/**
 * @file dataUtils.js
 * @description Shared data transformation utilities — IST date formatting
 *              and telemetry payload parsing used across all pages.
 */
import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const formatToIST = (dateString, pattern = 'dd MMM yyyy, hh:mm a') => {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        const timeZone = 'Asia/Kolkata';
        const zonedDate = toZonedTime(date, timeZone);
        return format(zonedDate, pattern);
    } catch (e) {
        return 'Invalid Date';
    }
};

export const parseTelemetry = (payload) => {
    if (!payload) return null;
    if (typeof payload === 'object') return payload; // Already parsed
    try {
        return JSON.parse(payload);
    } catch (e) {
        console.error("Failed to parse telemetry:", e);
        return null;
    }
};
